import classNames from 'clsx';
import React, { memo, ReactElement } from 'react';
import type { ItemNameProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';
import Name from 'reactApp/ui/Name/Name';

import styles from '../DataListItemRow.css';

export const ItemName = memo(({ name, ext, loading }: ItemNameProps): ReactElement => {
    return (
        <div className={classNames({ [styles.name]: true, [styles.loading]: loading })}>
            <Name name={name} extension={ext} truncate showTooltip />
        </div>
    );
});

ItemName.displayName = 'ItemName';
